import { createContext, useContext, useEffect, useState } from 'react';

const CMS_BASE_URL = 'https://api.dev.auxo.dk/public/content';

export const fetchCMSContent = async (collectionName) => {
  try {
    const response = await fetch(`${CMS_BASE_URL}/${collectionName}`);
    if (!response.ok) throw new Error('Failed to fetch CMS content');
    return await response.json();
  } catch (error) {
    console.error(`Error fetching ${collectionName}:`, error);
    return [];
  }
};

export const fetchCMSItemBySlug = async (lang, slug) => {
  try {
    const response = await fetch(`https://api.dev.auxo.dk/public/by-slug/${lang}/${slug}`);
    if (!response.ok) throw new Error('Failed to fetch item by slug');
    return await response.json();
  } catch (error) {
    console.error(`Error fetching slug ${slug}:`, error);
    return null;
  }
};
